import BranchWaitingTimePerService from "../../../components/branches/reports/daily/BranchWaitingTimePerService";
import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import { REPORT_TYPE_IDS } from "../../../store/constants";
import { WAITING_TIME_PER_SERVICE_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const DailyBranchWaitingTimePerService = ({ showFilterForm = true, showTitle = 1 }) => (
  <DailyGeneratedReportPage
    branchScoped={true}
    reportTypeId={REPORT_TYPE_IDS.daily_branch_waiting_time_per_service}
    title="Waiting Time Per Service"
    helmetTitle="Daily Branch Waiting Time Per Service"
    descriptionKey="WaitingTimePerServiceBranches"
    columnDefinitions={WAITING_TIME_PER_SERVICE_COLUMN_DEFINITIONS}
    defaultSortColumn="completed"
    showFilterForm={showFilterForm}
    showTitle={showTitle}
  >
    {({ data, renderConfig, onRenderConfigChange }) =>
      data.map((item, index) => (
        <BranchWaitingTimePerService
          key={index}
          branchId={item.branchId}
          branchIndex={index + 1}
          data={item.servicesData}
          branchName={item.branchName}
          numServices={item.numServices}
          renderConfig={renderConfig}
          onRenderConfigChange={onRenderConfigChange}
        />
      ))
    }
  </DailyGeneratedReportPage>
);

export default DailyBranchWaitingTimePerService;
